<template>
  <div>
    <div class="w-100 m-0 mb-1">
      <p class="bg-fade-primary-8 m-0 display-1 w-100">
        {{ day.name.substring(0, 3) }}
      </p>
    </div>
    <div class="flex-grow-1 d-flex flex-column bg-fade-primary-dark-9">
      <i
        class="wi my-5"
        :class="day.icon_class"
        style="font-size: 150px"
      />
      <p class="text-start display-1 text-white ps-2">
        {{ day.maxTemperature }}
      </p>
      <p class="text-end display-1 text-secondary pe-2">
        {{ day.minTemperature }}
      </p>
      <div
        v-if="day.precipitationType !== 'N/A' && day.precipitationProbability !== 0"
        class="d-flex flex-column flex-fill justify-content-end"
      >
        <p class="m-0 display-6 text-secondary">
          {{ day.precipitationType }}
        </p>
        <p class="m-0 display-4">
          {{ day.precipitationProbability }}%
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Weather',
  props: {
    day: {
      type: Object,
      required: true,
    },
  },
};
</script>
